<template>
  <div id="repayLoan">
    <headNav>
      <div slot="headNavText">{{$t('message.sch_hk')}}</div>
    </headNav>

    <div class="withdraw_content">
      <div>
        <div class="hkxx">
          <div style="display: flex;align-items: center" v-if="delayFeea==0"><img
            src="../../../assets/images/3x/repay.png" alt="" style="width: 24px;margin-right: 5px;">{{$t('message.sch_hk')}}
          </div>
          <div style="display: flex;align-items: center" v-if="delayFeea>0"><img
            src="../../../assets/images/3x/delay.png" alt="" style="width: 24px;margin-right: 5px;">{{$t('message.repay_yq')}}
          </div>
          <p v-if="delayFeea==0">{{$t('message.repay_yq1')}}</p>
          <p v-if="delayFeea>0" style="color: #FF0000!important;">{{$t('message.repay_yq2')}}</p>
          <div>
            <div>{{$t('message.repay_time')}}</div>
            <div>{{yinPayTime}}</div>
          </div>
        </div>
        <div class="circle">
          <div></div>
          <div></div>
        </div>
        <div class="item">
          <div>{{$t('message.orderId')}}</div>
          <div>{{orderId}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.with_tx_jkje')}}</div>
          <div>{{loan_total}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.bill_jkqx')}}</div>
          <div>{{loan_day}}{{$t('message.tian')}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.pay_total')}}</div>
          <div>{{repayMount}}{{coin}}</div>
        </div>
        <div class="item">
          <div>{{$t('message.repay_yqf')}}</div>
          <div :style="delayFeea>0?'color:red;font-weight:600':''">{{delayFee}}{{coin}}</div>
        </div>
        <!--                <div class="item" @click="choose('repayFS',repaySty)">-->
        <!--                  <div>{{$t('message.repay_style')}}</div>-->
        <!--                  <div style="display: flex;align-items: center">-->
        <!--                    {{repayFS}}-->
        <!--                    <van-icon name="arrow"/>-->
        <!--                  </div>-->
        <!--                </div>-->
        <div class="item" @click="choose('repayLX',repayLXList)">
          <div>{{$t('message.repay_hklx')}}</div>
          <div style="display: flex;align-items: center">
            {{repayLX}}
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="item halfAmount" v-if="halfAmountShow">
          <div>{{$t('message.repay_money')}}</div>
          <div style="display: flex;align-items: center">
            <!--            Nhập số tiền  输入还款金额-->
            <van-field v-model="halfAmount" type="number" label="" input-align="right" autofocus placeholder="Nhập số tiền"/>
          </div>
        </div>
      </div>

    </div>
    <div style="width: 93%;font-size: 12px;color:#FF5553;margin: 0 auto 0">
      {{$t('message.repay_tq_tips')}}
      <van-button type="primary" block style="margin-top: 15px" @click="showInfos" id="btns">{{$t('message.com_repay')}}
      </van-button>
    </div>

    <van-dialog
      v-model="showInfo"
      :title="showTitle"
      show-cancel-button
      :confirm-button-text="$t('message.determine')"
      :cancel-button-text="$t('message.cancel')"
    >
      <!--      线上-->
      <div v-if="showTips==2">
        <div class="items">
          <div >
            <p>{{$t('message.repay_skdw')}}</p>
          </div>
          <div >
            <p>{{hubank}}</p>
          </div>
        </div>
        <div class="items">
          <div >
            <p>{{$t('message.repay_bank_news')}}</p>
          </div>
          <div >
            <p>{{bankName}}</p>
          </div>
        </div>
        <!--        <div class="items">-->
        <!--          <div >-->
        <!--            <p>{{$t('message.repay_zh_bank')}}</p>-->
        <!--          </div>-->
        <!--          <div >-->
        <!--            <p>{{bankbranch}}</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="items">
          <div >
            <p>{{$t('message.repay_zh')}}</p>
          </div>
          <div >
            <p>{{bankcard}}</p>
          </div>
        </div>
        <div class="items" v-if="repayStyNum==1">
          <div >
            <p>{{$t('message.repay_next_date')}}</p>
          </div>
          <div >
            <p>{{nextPayTime}}</p>
          </div>
        </div>
        <!--        <div class="items">-->
        <!--          <div >-->
        <!--            <p>{{$t('message.repay_map_new')}}</p>-->
        <!--          </div>-->
        <!--          <div >-->
        <!--            <p>{{banklink}}</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="items">
          <div >
            <p>{{$t('message.repay_money')}}</p>
          </div>
          <div >
            <p>{{add_comma_toThousands(repayMen)}}{{coin}}</p>
          </div>
        </div>
        <div class="items">
          <div >
            <p>{{$t('message.repay_server_money')}}</p>
          </div>
          <div >
            <p>{{serviceFee}}</p>
          </div>
        </div>
      </div>
    </van-dialog>
    <!--      以上是还款-->
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-picker :columns='valueMDlist' @change="onChange" @cancel="onCancel" :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')"
      />
    </van-popup>
    <van-dialog v-model="showLink" :title="$t('message.deal_photo_cz')" show-cancel-button @confirm="openLink" :cancel-button-text="$t('message.cancel')" :confirm-button-text="$t('message.determine')">
      <p style="padding: 0 15px">Khi thanh toán vui lòng truy cập đường link mới nhất, không truy cập vào link cũ hay quét mã QR cũ</p>
      <!--      请不要保留链接，还款时获取最新链接-->
    </van-dialog>
  </div>
</template>

<script>
  import {RepaymentMoney} from '../../../ports/port'
  import {RepaymentXqMoney} from '../../../ports/port'
  import {
    getBankAccounts,
    RepaymentMoneyTypes,
    isXuQi,
    sassRepaySty,
    sassGFaccount,
    sassRepayMoney,
    sassRepaySecdule
  } from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "repayLoan",
    data() {
      return {
        bankAccountName: '',//户名
        bankAccountNumber: '',//账号
        bankAccount: '',//银行
        hubank: '',//收款单位
        bankName: '',//银行名
        bankbranch: '',//支行名
        bankcard: '',//银行卡号
        getordercode: '',//交易吗
        site: '',//便利店地址
        getname: '',//ximgm
        tel: '',//dianhua
        nextPayTime: '',//下期还款时间
        banklink: '',//地图信息
        repayMen: '',//还款金额
        serviceFee: '',//服务费
        showInfo: false,
        show: false,
        showTips: '',//还款展示窗口类型    0=》银行  1=》商店  2=》账户
        repayStyNum: '',//还款类型0=》全款   1=》续期
        showTitle: '',//模态框的展示头
        orderId: '',//订单编号
        repayMount: '',//应还金额
        valueMD: '',//中间值，选择时使用
        valueMDlist: [],//中间列表选择植
        repayFS: this.$t('message.qxz_sty'),//还款方式
        repayLX: this.$t('message.quank'),//还款类型   默认全款
        radio: 1,
        payTotal: 2,
        getDataTypes: [],//存放获取的还款种类
        // repaySty:[this.$t('message.xians'),this.$t('message.xianxia'),this.$t('message.banksAccount')],
        repaySty: [],
        repayLXList: [this.$t('message.quank'),this.$t('message.xuq')],//Thanh toán 1 phần  =>部分还款
        isOrder: JSON.parse(sessionStorage.getItem('indexJH')),//获取是否有订单
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        showLoading: false,
        beizhu: '',
        url_orderid: '',//路由中获得的订单编号
        url_userid: '',//路由中获得的userid
        url_repayMenoy: '',
        showReback: false,
        repayLoanBanklist: [],//还款银行账户
        yinPayTime: '',
        delayFee: '',
        delayFeea: '',
        coin: this.$coin,
        loan_total:'',//借款总额,
        loan_day:'',//借款天数
        halfAmount:"",
        halfAmountShow:false,
        showLink:false,
        link:''
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.orderId = this.$route.query.orderid;
      this.$store.commit('edit', true);//打开全局的loading
      sassRepaySecdule({orderid:this.orderId})
        .then(res=>{
          this.$store.commit('edit', false);//关闭全局的loading
          if(res.data.code==200){
            this.repayMount = this.add_comma_toThousands(res.data.data.ying_pay_money);
            this.yinPayTime = res.data.data.next_pay_time;
            this.delayFee = this.add_comma_toThousands(res.data.data.delayfee);
            this.delayfeea = res.data.data.delayfee;
            this.loan_total = this.add_comma_toThousands(res.data.data.loan_amount);
            this.loan_day = res.data.data.loan_day;
          }else{
            this.$notify({type: 'danger', message: res.data.msg});
          }
        }).catch(err => {
        this.$store.commit('edit', false);//关闭全局的loading
        if (err.toString().indexOf('timeout') != -1) {
          this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
        }
      });

// 判断是否可以续期还是全款
      isXuQi({orderid: this.orderId})
        .then(res => {
          if (res.data.code != 200) {
            this.repayLXList.pop();
          }
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
      sassRepaySty({orderid: this.orderId})
        .then(res => {
          this.getDataTypes = res.data.data;
          res.data.data.map((el, index) => {
            this.repaySty.push(el.name);
          });
          //默认全款
          this.repayFS =res.data.data[0].name;
          this.repayStyNum=0;
          this.showTips = res.data.data[0].type;
          this.showTitle = res.data.data[0].name;
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        })
    },
    methods: {
      //判断是否有订单
      checkHasOrder() {
        if (this.tk != null && this.$route.query.orderid == undefined) {//登录后的
          if (typeof (this.isOrder.data.orderid) == 'undefined') {
            this.$dialog.alert({
              message: this.$t('message.order_no_message'),
              confirmButtonText: this.$t('message.determine')
            }).then(() => {
              this.$router.push("/home");
            });
          } else if (this.isOrder.code == 1 || this.isOrder.code == 2) {
            this.orderId = this.isOrder.data.orderid;
            this.repayMount = this.isOrder.data.rebackmoney;
          }
        } else if (this.tk == null || (this.tk != null && this.$route.query.orderid != undefined)) {
          //直接url进入的
          this.orderId = this.url_orderid;
          this.repayMount = this.url_repayMenoy;
        }

      },
      //点击展示还款信息
      showInfos() {
        this.$router.push({path: '/schedule/repay/repayCenter', query: {orderid: this.orderId,repaySty:this.repayStyNum}});
        // if (this.repayFS != "" && this.repayLX != "") {
        //   this.$store.commit('edit', true);//关闭全局的loading
        //   if (this.repayStyNum == 0) {//全款
        //     if (this.showTips == 1) {//官方账户还款
        //       sassGFaccount({orderid: this.orderId})
        //         .then(res => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (res.data.code == 200) {
        //             let dataStr = JSON.stringify(res.data.data);
        //             this.$router.push({path:'/schedule/repay/repayAccount', query: {'data': dataStr}})
        //           } else {
        //             this.$notify({type: 'danger', message: res.data.msg});
        //           }
        //         })
        //         .catch(err => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (err.toString().indexOf('timeout') != -1) {
        //             this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
        //           }
        //         })
        //     } else {//银行，商店还款
        //       let data;
        //       if(this.halfAmountShow){
        //         data ={userid: this.tk.userid, orderid: this.orderId, type: this.repayStyNum,money:this.halfAmount}
        //         if(this.halfAmount-0<100000){
        //           this.$toast({message: 'Ít nhất 100.000', type: 'danger', icon: 'fail'});
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           return false
        //         }
        //       }else{
        //         data ={userid: this.tk.userid, orderid: this.orderId, type: this.repayStyNum}
        //       }
        //       sassRepayMoney(data)
        //         .then(res => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if(res.data.code==200){
        //             if(res.data.data.length!=0){
        //               if(res.data.data && res.data.data.type==2){
        //                 this.showLink = true;
        //                 this.link = res.data.data.repay_url;
        //               }else{
        //                 // 以下是虚拟卡
        //                 this.showInfo=true;
        //                 this.hubank=res.data.data.accountName;
        //                 this.bankName=res.data.data.bankName;
        //                 this.bankbranch=res.data.data.branchBankName;
        //                 this.bankcard=res.data.data.accountNo;
        //                 this.banklink=res.data.data.bankLink;
        //                 this.serviceFee=res.data.data.serviceFee;
        //                 this.repayMen=res.data.data.money;
        //               }
        //             }
        //           }else{
        //             this.$notify({ type: 'danger', message: res.data.msg});
        //           }
        //         })
        //         .catch(err => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (err.toString().indexOf('timeout') != -1) {
        //             this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
        //           }
        //         })
        //     }
        //   // } else if (this.repayStyNum == 1) {//续期
        //   } else{//续期 或者部分还款
        //     if (this.showTips == 1) {//官方账户还款
        //       sassGFaccount({orderid: this.orderId})
        //         .then(res => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (res.data.code == 200) {
        //             // this.showInfo = true;
        //             // this.showLoading = false;
        //             // this.bankAccountName = res.data.data.name;
        //             // this.bankAccountNumber = res.data.data.card_number;
        //             // this.bankAccount = res.data.data.bank_type;
        //             // this.beizhu = res.data.data.mark;
        //             let dataStr = JSON.stringify(res.data.data);
        //             this.$router.push({path:'/schedule/repay/repayAccount', query: {'data': dataStr}})
        //           } else {
        //             this.$notify({type: 'danger', message: res.data.msg});
        //           }
        //         })
        //         .catch(err => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (err.toString().indexOf('timeout') != -1) {
        //             this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
        //           }
        //         })
        //     } else {
        //       let data;
        //       if(this.halfAmountShow){
        //         data = {userid: this.tk.userid, orderid: this.orderId, type: this.repayStyNum,money:this.halfAmount};
        //         if(this.halfAmount-0<100000){
        //           this.$toast({message: 'Ít nhất 100.000', type: 'danger', icon: 'fail'});
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           return false
        //         }
        //       }else{
        //         data = {userid: this.tk.userid, orderid: this.orderId, type: this.repayStyNum};
        //       }
        //       sassRepayMoney(data)
        //         .then(res => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if(res.data.code==200){
        //             // this.showInfo=true;
        //             // this.hubank=res.data.data.accountName;
        //             // this.bankName=res.data.data.bankName;
        //             // this.bankbranch=res.data.data.branchBankName;
        //             // this.bankcard=res.data.data.accountNo;
        //             // this.banklink=res.data.data.bankLink;
        //             // this.serviceFee=res.data.data.serviceFee;
        //             // this.repayMen=res.data.data.money;
        //             // this.nextPayTime=res.data.data.reback_date;
        //             if(res.data.data.length!=0){
        //               if(res.data.data && res.data.data.type==2){
        //                 this.showLink = true;
        //                 this.link = res.data.data.repay_url;
        //               }else{
        //                 // 以下是虚拟卡
        //                 this.showInfo=true;
        //                 this.hubank=res.data.data.accountName;
        //                 this.bankName=res.data.data.bankName;
        //                 this.bankbranch=res.data.data.branchBankName;
        //                 this.bankcard=res.data.data.accountNo;
        //                 this.banklink=res.data.data.bankLink;
        //                 this.serviceFee=res.data.data.serviceFee;
        //                 this.repayMen=res.data.data.money;
        //               }
        //             }
        //           }else{
        //             this.$notify({ type: 'danger', message: res.data.msg});
        //           }
        //         })
        //         .catch(err => {
        //           this.$store.commit('edit', false);//关闭全局的loading
        //           if (err.toString().indexOf('timeout') != -1) {
        //             this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
        //           }
        //         })
        //     }
        //   }
        // } else {
        //   this.$notify({type: 'danger', message: this.$t('message.jcNEWS')});
        // }


      },
      openLink(){
        window.open(this.link);
      },
      choose(a, b) {
        this.show = true;
        this.valueMD = a;
        this.valueMDlist = b;
      },
      //关闭选择框
      onCancel() {
        this.show = false;
      },
      //选择框滚动时，表单内的值变化
      onChange(picker, value, index) {
        this[this.valueMD] = value;
      },
      //确定选择的值
      onConfirm(value, index) {
        this[this.valueMD] = value;
        if (this.valueMD == 'repayFS') {//选择还款方式
          this.getDataTypes.map((el, i) => {
            if (el.name == value) {
              this.showTips = el.type;
            }
          })
          // this.showTips=Number(index)+1;
          this.showTitle = value;
        } else if (this.valueMD == 'repayLX') {//选择全款或者续期
          this.repayStyNum = index;
          // if(index==1){
          //   this.halfAmountShow = true;
          // }else{
          //   this.halfAmountShow = false;
          // }
        }
        this.show = false;
      },
      goBack() {
        this.$router.go(-1)
      },
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
    }
  }
</script>

<style scoped lang="scss">
  #repayLoan {
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .container {
      background: #F2F4FB;
      padding: 0 0 1px;
      /*min-height: 76vh;*/
      flex: 1;
      position: relative;

      .title {
        text-align: center;
        background: white;
        font-size: 20px;
        padding: 10px 0;
        border-bottom: 1px solid #F2F4FB;
        position: relative;

        i {
          position: absolute;
          left: 20px;
          font-size: 25px;
        }
      }

      .banksBox {
        background: white;
        width: 87%;
        padding: 15px;
        margin: 15px auto;
        border-radius: 8px;

        button {
          background: $color;
          border: 1px solid $color;
          border-radius: 5px;
        }

        /deep/ .el-form-item__content {
          display: inline-block;
          width: 57%;
        }

        /deep/ .el-form-item__label {
          width: 140px;
        }
      }
    }

    /deep/ .van-dialog__header {
      background: $color;
      padding: 12px 0;
    }

    /deep/ .van-dialog__content {
      /*padding: 0 10px;*/
    }

    /deep/ .van-dialog__header {
      color: white;
      font-size: 18px;
    }

    /deep/ .van-dialog__content .div-14 p {
      /*word-break: break-all;*/
      padding-left: 15px;
      overflow: auto;
    }

    /deep/ .van-loading.van-loading--circular.van-loading--vertical {
      position: absolute !important;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(200, 201, 204, 0.6);
      z-index: 100;
    }

    /deep/ .van-loading,
    /deep/ .van-loading__text {
      color: $color;
    }

    .work_xt {
      color: $color;
    }

    .gfzh {
      p {
        margin: 6px 0;
      }
    }

    .withdraw_content {
      width: 93%;
      margin: 15px auto;
      background: #fff;
      padding: 0 15px 15px;
      box-sizing: border-box;
      border-radius: 15px;
      position: relative;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
      margin-top: 1.6rem;

      .circle {
        :nth-child(1) {
          position: absolute;
          top: 119px;
          left: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F5F5F5;
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-right: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);
          border-radius: 0 20px 20px 0; /* 左上、右上、右下、左下 */
        }

        :nth-child(2) {
          position: absolute;
          top: 119px;
          right: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F5F5F5;
          border-radius: 20px 0 0 20px; /* 左上、右上、右下、左下 */
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-left: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);

        }
      }

      .hkxx {
        padding-top: 20px;
        border-bottom: 1px dotted #E9E9E9;

        > :nth-child(1) {
          font-size: 18px !important;
          font-weight: 600;
          color: #080808 !important;
        }

        > :nth-child(2) {
          font-size: 12px !important;
          color: #D1D1D1 !important;
        }

        > :nth-child(3) {
          font-size: 15px !important;
          color: #4F4E4E !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 10px;

          > :nth-child(1) {
            font-weight: 600;
          }

          > :nth-child(2) {
            background-color: #D4E3FD;
            color: #014CCC;
            padding: 5px 20px;
            border-radius: 40px;
            font-size: 12px;
          }
        }
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.44rem 0;
        font-size: 14px;
        border-bottom: 1px solid #E9E9E9;

        div {
          color: gray;
        }

        > div:nth-child(1) {
          color: #8E97A6;
        }
      }

    }

    #btns {
      @include defaultBtn
    }
    .items{
      display: flex;
      padding: 0 6px;
      >div{
        flex: 1;
      }
      :nth-child(2) {
        text-align: right;
      }
    }

  }
  /deep/ .halfAmount .van-cell{
    padding-top: 0;
    padding-bottom: 0;
    .van-field__control{
      color: gray;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/repay/repayLoan.vue